// polyfills

// promise
import 'promise-polyfill/src/polyfill';

// object assign
require('es6-object-assign/auto');

// object foreach
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

if (process.env.NODE_ENV === 'production') {
    flare.light(process.env.MIX_FLARE_KEY);
}
